import ItemView from './PaymentAccount.js';
import ListEditablesView from 'commons/views/ListEditables.js';
import modal from 'helpers/modal';
import template from
    'employer/templates/settings/integrations/quickbooks/PaymentAccounts.ejs';

module.exports = ListEditablesView.extend({
    modelViews: [],
    modalView: null,

    events: function() {
        var parentEvents = _.isFunction(ListEditablesView.prototype.events) ?
            ListEditablesView.prototype.events() :
            ListEditablesView.prototype.events;

        return _.extend(_.clone(parentEvents), {
        });
    },

    initialize: function(options) {
        this.options = _.defaults(options || {}, {
            template: template,
            ModelView: ItemView,
            qbAccounts: []
        });
        this.options.templateExtra = {
            qbAccounts: this.options.qbAccounts
        };

        return ListEditablesView.prototype.initialize.apply(
            this, [this.options]
        );
    },

    renderModel: function(model) {
        var view = new this.options.ModelView({
            model: model,
            qbAccounts: this.options.qbAccounts
        });
        this.$('.js-model-views').append(view.$el);
        this.modelViews.push(view);
        return this;
    },

    save: function(ev) {
        ListEditablesView.prototype.save.apply(this, [ev]).then(function() {
            modal.showAlertSuccess('Mappings have been saved');
        });
        return false;
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/settings/integrations/quickbooks/PaymentAccounts.js